import React from "react";
import { IAttributes, Types } from "../../reducers/project";
import styled from "styled-components";
import content from "../../content";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedAttributes } from "../../reducers/project/selectors";
import TextInput from "../Input/TextInput";
import NumberInput from "../Input/NumberInput";
import { Check } from "@material-ui/icons";
import { ProjectActions } from "../../reducers/project/actionsNames";

const Wrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100px;
  flex-basis: 100px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #7a7c8b;
  margin-bottom: 15px;
  min-width: 0;
  cursor: pointer;
`;

const InputHeader = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: -0.01em;
  width: 100%;
  color: #1e2029;
  margin-bottom: 10px;
`;

const InputDescription = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  width: 100%;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #7a7c8b;
  margin-bottom: 15px;
`;

const Selected = styled.div`
  width: 36px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin-top: -25px;
`;

function Attribute({ attr, onClick }: IAttribute) {
    const selected = useSelector(getSelectedAttributes);
    const dispatch = useDispatch();

    const changeAttr = (e) => {
        const v = Math.abs(
            Number(
                e.currentTarget?.value
                    ? String(e.currentTarget?.value).replace(/\D+/g, "")
                    : e.currentTarget?.value
            )
        );
        dispatch({
            type: ProjectActions.ChangeAttrib,
            id: attr.id,
            value: v === 0 ? 1 : v,
        });
    };

    switch (attr.type) {
        case Types.Select:
            return (
                <Wrapper onClick={onClick}>
                    <img
                        style={{
                            border: selected.some((a) => a.id == attr.id)
                                ? "1px solid #1B576A"
                                : "1px solid #ffffff",
                            borderRadius: "4px",
                        }}
                        src={attr.pimg}
                        width={70}
                        height={70}
                    />
                    <div
                        style={{
                            textAlign: "center",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {content.getValue(attr.name)}
                    </div>
                    {/*<div*/}
                    {/*  style={{*/}
                    {/*    fontWeight: 600,*/}
                    {/*    fontSize: "11px",*/}
                    {/*    color: "#1b576a",*/}
                    {/*    textAlign: "center",*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  {attr.price} {content.getValue("price_surfix")}*/}
                    {/*</div>*/}
                    {selected.some((a) => a.id == attr.id) && (
                        <Selected>
                            <Check />
                        </Selected>
                    )}
                    {/*<Radio checked={selected.includes(attr)} />*/}
                </Wrapper>
            );
        case Types.Input:
            return (
                <div>
                    <InputHeader>{content.getValue(attr.name)}</InputHeader>
                    <InputDescription>
                        {content.getValue(attr.description)}
                    </InputDescription>
                    <TextInput
                        value={attr.value}
                        onChange={changeAttr}
                        placeholder={attr.placeholder}
                    />
                </div>
            );
        case Types.Picker:
            return (
                <div style={{ marginBottom: "20px", width: "100%" }}>
                    <InputHeader>{content.getValue(attr.name)}</InputHeader>
                    <NumberInput
                        value={attr.value}
                        onChange={changeAttr}
                        style={{ width: "100%" }}
                    />
                </div>
            );
    }
}

export interface IAttribute {
    attr: IAttributes;
    onClick?: () => void;
}
export default Attribute;
